import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'kodit-saldo-card-skeleton',
  templateUrl: './saldo-card-skeleton.component.html',
  styleUrls: ['./saldo-card-skeleton.component.scss'],
})
export class SaldoCardSkeletonComponent implements OnInit {
  @Input() showTopText: boolean;
  @Input() showTopText2?: boolean;
  @Input() showTopText3?: boolean;
  @Input() showMainText: boolean;
  @Input() showMainText2?: boolean;
  @Input() showMainText3?: boolean;
  @Input() showBottomText?: boolean;
  @Input() showBottomText2?: boolean;
  @Input() showBottomText3?: boolean;
  @Input() showProgresPercent?: boolean;

  constructor() {}

  ngOnInit(): void {}
}
